import { render, staticRenderFns } from "./allDeviceDetail.vue?vue&type=template&id=6dffd0ca&scoped=true"
import script from "./allDeviceDetail.vue?vue&type=script&lang=js"
export * from "./allDeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./allDeviceDetail.vue?vue&type=style&index=0&id=6dffd0ca&prod&lang=scss&scoped=true"
import style1 from "./allDeviceDetail.vue?vue&type=style&index=1&id=6dffd0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffd0ca",
  null
  
)

export default component.exports